import { MapPin, ZoomIn } from "lucide-react";
import { Button } from "@/components/ui/button";

type Rectangle = { x: number; y: number; width: number; height: number };
type ProductCapture = {
	src: string;
	width: number;
	height: number;
	crop: Rectangle;
	rect: Rectangle;
};

export function ProductScreenshot({ screen, alt, location, caption }: {
	screen: ProductCapture;
	alt: string;
	location: string;
	caption: string;
}) {
	const { crop, rect } = screen;
	return (
		<figure>
			<div className="flex flex-wrap items-center justify-between gap-3 border-t border-border bg-muted/30 px-4 py-3 sm:px-5">
				<p className="flex min-w-0 flex-1 items-start gap-2 text-xs leading-5 text-muted-foreground"><MapPin className="mt-0.5 size-3.5 shrink-0" aria-hidden="true" />{location}</p>
				<Button asChild variant="outline" className="min-h-11 text-xs">
					<a href={screen.src} target="_blank" rel="noopener noreferrer"><ZoomIn className="size-4" aria-hidden="true" />View larger<span className="sr-only"> (opens full screenshot in a new tab)</span></a>
				</Button>
			</div>
			<div className="border-y border-border bg-white">
				<svg role="img" aria-label={alt} viewBox={`${crop.x} ${crop.y} ${crop.width} ${crop.height}`} className="mx-auto block h-auto w-full" style={{ aspectRatio: `${crop.width} / ${crop.height}`, ...(crop.height > crop.width ? { maxWidth: 320 } : {}) }}>
					<image href={screen.src} x={0} y={0} width={screen.width} height={screen.height} />
					<rect x={rect.x - 4} y={rect.y - 4} width={rect.width + 8} height={rect.height + 8} rx={10} fill="none" stroke="white" strokeWidth={5} vectorEffect="non-scaling-stroke" aria-hidden="true" />
					<rect x={rect.x - 4} y={rect.y - 4} width={rect.width + 8} height={rect.height + 8} rx={10} fill="none" stroke="#c8553d" strokeWidth={2} vectorEffect="non-scaling-stroke" aria-hidden="true" />
				</svg>
			</div>
			<figcaption className="px-4 py-3 text-[11px] leading-5 text-muted-foreground">{caption} The orange outline marks the control to use in the app.</figcaption>
		</figure>
	);
}
